import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./social/social.module').then( m => m.SocialPageModule)
  },
  {
    path: 'social',
    loadChildren: () => import('./social/social.module').then( m => m.SocialPageModule)
  },
    {
        path: 'welcome',
        loadChildren: () => import('./welcome/welcome.module').then(m => m.WelcomePageModule)
    },
    {
    path: 'u',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'crm',
    loadChildren: () => import('./crm/crm.module').then(m => m.CrmModule)
  },
  {
    path: 'calc',
    loadChildren: () => import('./calculator/calculator.module').then(m => m.CalculatorModule)
  },
  {
    path: 'instajet',
    loadChildren: () => import('./instajet/instajet.module').then(m => m.InstajetModule)
  },
  {
        path: 'data',
        loadChildren: () => import('./data/data.module').then(m => m.DataPageModule)
    },
  {
    path: 'list',
    loadChildren: () => import('./list/list.module').then(m => m.ListPageModule)
  },
    {
        path: 'tabs',
        loadChildren: () => import('./tabs/tabs/tabs.module').then(m => m.TabsPageModule)
    },
  {
    path: 'popovercomponent',
    loadChildren: () => import('./popovercomponent/popovercomponent.module').then( m => m.PopovercomponentPageModule)
  },
  {
    path: 'ion-modal',
    loadChildren: () => import('./ion-modal/ion-modal.module').then( m => m.IonModalPageModule)
  },
  {
    path: 'alertmodal',
    loadChildren: () => import('./alertmodal/alertmodal.module').then( m => m.AlertmodalPageModule)
  },
  {
    path: 'history',
    loadChildren: () => import('./history/history.module').then( m => m.HistoryPageModule)
  },
  {
    path: 'help',
    loadChildren: () => import('./help/help.module').then( m => m.HelpPageModule)
  },
  {
    path: 'addpost',
    loadChildren: () => import('./addpost/addpost.module').then( m => m.AddpostPageModule)
  },
  {
    path: 'post',
    loadChildren: () => import('./post/post.module').then(m => m.PostModule)
  },
  {
    path: 'postpopover',
    loadChildren: () => import('./postpopover/postpopover.module').then( m => m.PostpopoverPageModule)
  },
  {
    path: 'edit-user',
    loadChildren: () => import('./edit-user/edit-user.module').then( m => m.EditUserPageModule)
  },
  {
    path: 'edit-post',
    loadChildren: () => import('./edit-post/edit-post.module').then( m => m.EditPostPageModule)
  },
  {
    path: 'market',
    loadChildren: () => import('./market/market.module').then( m => m.MarketPageModule)
  },
  {
    path: 'users',
    loadChildren: () => import('./users/users.module').then( m => m.UsersPageModule)
  }
  ,
  {
    path: 'ecalendar',
    loadChildren: () => import('./ecalendar/ecalendar.module').then(m => m.EcalendarModule)
  },
  {
    path: 'loan',
    loadChildren: () => import('./loan/loan.module').then(m => m.LoanModule)
  },
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
